module.exports = __webpack_public_path__ + "static/media/icon_arrow.7b11d5de.svg";